import { render, staticRenderFns } from "./CompetitionsSummary.vue?vue&type=template&id=f945fe44&"
import script from "./CompetitionsSummary.vue?vue&type=script&lang=js&"
export * from "./CompetitionsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports